import { combineReducers } from "redux";
import { userReducer } from "./userReducer";
import { userRoleReducer } from "./userRoleReducer";
import { configurationReducer } from "./configurationReducer";
import { catalogRoleReducer } from "./catalogRoleReducer";

import { authReducer } from "./authReducer";
import { trackingHistoryReducer } from "./trackingHistoryReducer";

import { catalogReducer } from "./catalogReducer";
import { catalogCiiuReducer } from "./catalogCiiuReducer";
import { locationReducer } from "./locationReducer";

import { searchInfoReducer } from "./searchInfoReducer";

import { catalogCiiuInfoReducer } from "./catalogCiiuInfoReducer";

import { locationCountryReducer } from "./locationCountryReducer";

import { viewModalReducer } from "./viewModalReducer";

import { moduleConfigReducer } from "./moduleConfigReducer";
import { ruleFlowReducer } from "./ruleFlowReducer";
import { roleFlowReducer } from "./roleFlowReducer";
import { flowReducer } from "./flowReducer";
import { flowEngineReducer } from "./flowEngineReducer";
import { flowRoleCiiuAssignmentReducer } from "./flowRoleCiiuAssignmentReducer";
import { flowModuleConfigReducer } from "./flowModuleConfigReducer";
import { flowReassignmentReducer } from "./flowReassignmentReducer";
import { flowChecklistReducer } from "./flowChecklistReducer";
import { flowAssignmentPolicyReducer } from "./flowAssignmentPolicyReducer";
import { flowCoverageReducer } from "./flowCoverageReducer";
import { flowCmiReducer } from "./flowCmiReducer";
import { flowListFilterReducer } from "./flowListFilterReducer";
import { specialistSelectionReducer } from "./specialistSelectionReducer";

import { menuReducer } from "./menuReducer";
import { catalogSectionReducer } from "./catalogSectionReducer";

import { catalogPhaseReducer } from "./catalogPhaseReducer";
import { catalogInstitutionReducer } from "./catalogInstitutionReducer";
import { catalogModuleReducer } from "./catalogModuleReducer";
import { importDataTechnologyReducer } from "./importDataTechnologyReducer";
import { importDataAlternativeReducer } from "./importDataAlternativeReducer";
import { importDataExperienceReducer } from "./importDataExperienceReducer";
import { importDataInnovationReducer } from "./importDataInnovationReducer";
import { importDataAssistanceReducer } from "./importDataAssistanceReducer";
import { importDataFinancialReducer } from "./importDataFinancialReducer";
import { importDataRegulationReducer } from "./importDataRegulationReducer";
import { importDataVisionReducer } from "./importDataVisionReducer";

import { technologyReducer } from "./technologyReducer";
import { alternativeReducer } from "./alternativeReducer";
import { experienceReducer } from "./experienceReducer";
import { innovationReducer } from "./innovationReducer";
import { assistanceReducer } from "./assistanceReducer";
import { financialReducer } from "./financialReducer";
import { regulationReducer } from "./regulationReducer";
import { visionReducer } from "./visionReducer";
import { searchResultReducer } from "./searchResultReducer";
import { compareResultReducer } from "./compareResultReducer";

import { catalogTypeReducer } from "./catalogTypeReducer";

import { userRoleModuleReducer } from "./userRoleModuleReducer";
import { catalogContinentReducer } from "./catalogContinentReducer";
import { catalogRegionReducer } from "./catalogRegionReducer";
import { catalogCountryReducer } from "./catalogCountryReducer";
import { statisticReducer } from "./statisticReducer";
import { searchHistoryReducer } from "./searchHistoryReducer";
import { groupConcernReducer } from "./groupConcernReducer";
import { suggestCaseReducer } from "./suggestCaseReducer";
import { userInterestReducer } from "./userInterestReducer";
import { supportFormReducer } from "./supportFormReducer";
import { homeContentReducer } from "./homeContentReducer";
import { specialistGuideReducer } from "./specialistGuideReducer";
import { searchKeyTermReducer } from "./searchKeyTermReducer";

export const rootReducer = combineReducers({
    user: userReducer,
    userRole: userRoleReducer,
    configuration:configurationReducer,
    catalogRole:catalogRoleReducer,
    
    auth:authReducer,
    tracking:trackingHistoryReducer,
    
    catalog:catalogReducer,
    catalogCiiu: catalogCiiuReducer,
    location: locationReducer,

    catalogCiiuInfo : catalogCiiuInfoReducer,
    
    locationCountry: locationCountryReducer,
    
    viewModal :viewModalReducer,

    moduleConfig: moduleConfigReducer,
    ruleFlow: ruleFlowReducer,
    roleFlow : roleFlowReducer,
    flow: flowReducer,
    flowEngine: flowEngineReducer,
    flowRoleCiiuAssignment: flowRoleCiiuAssignmentReducer,
    flowModuleConfig: flowModuleConfigReducer,
    flowReassignment: flowReassignmentReducer,
    flowChecklist: flowChecklistReducer,
    flowAssignmentPolicy: flowAssignmentPolicyReducer,
    flowCoverage: flowCoverageReducer,
    flowCmi: flowCmiReducer,
    flowListFilter: flowListFilterReducer,
    specialistSelection: specialistSelectionReducer,
    menu: menuReducer,
    catalogSection: catalogSectionReducer,

    catalogPhase: catalogPhaseReducer,
    catalogInstitution: catalogInstitutionReducer,
    catalogModule:catalogModuleReducer,

    importDataTechnology:importDataTechnologyReducer,
    importDataAlternative:importDataAlternativeReducer,
    importDataExperience:importDataExperienceReducer,
    importDataInnovation:importDataInnovationReducer,
    importDataAssistance:importDataAssistanceReducer,
    importDataFinancial:importDataFinancialReducer,
    importDataRegulation:importDataRegulationReducer,
    importDataVision:importDataVisionReducer,

    technology: technologyReducer,
    alternative: alternativeReducer,
    experience: experienceReducer,
    innovation: innovationReducer,
    assistance: assistanceReducer,
    financial: financialReducer,
    regulation: regulationReducer,
    vision: visionReducer,

    searchInfo:searchInfoReducer,
    searchResult:searchResultReducer,
    compareResult:compareResultReducer,

    catalogType:catalogTypeReducer,
    userRoleModule:userRoleModuleReducer,

    catalogContinent:catalogContinentReducer,
    catalogRegion:catalogRegionReducer,
    catalogCountry:catalogCountryReducer,
    statistic:statisticReducer,
    searchHistory: searchHistoryReducer,

    groupConcern: groupConcernReducer,

    suggestCase: suggestCaseReducer,
    userInterest: userInterestReducer,
    supportForm: supportFormReducer,
    homeContent: homeContentReducer,
    specialistGuide: specialistGuideReducer,
    searchKeyTerm: searchKeyTermReducer

})